module.exports = __webpack_public_path__ + "static/media/masterchief.b055343e.jpeg";